import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faPlus,
  faUsers,
  faStickyNote,
  faScrewdriverWrench,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function AdminTools() {
  const navigate = useNavigate();

  const adminActions = [
    {
      title: "Create new user",
      description: "Invite a team member and assign the correct access level.",
      icon: faPlus,
      variant: "secondary",
      onClick: () => navigate("/createUser"),
      buttonText: "Create user",
    },
    {
      title: "Review activity logs",
      description: "Monitor downloads and user actions for compliance checks.",
      icon: faPaperPlane,
      variant: "indigo",
      onClick: () => navigate("/getLogs"),
      buttonText: "Open logs",
    },
    {
      title: "Manage user accounts",
      description: "View, update, or disable accounts from the user directory.",
      icon: faUsers,
      variant: "pink",
      onClick: () => navigate("/manageUsers"),
      buttonText: "Manage users",
    },
    {
      title: "Website updates",
      description:
        "Publish release notes and share platform changes with staff.",
      icon: faStickyNote,
      variant: "orange",
      onClick: () => navigate("/updates"),
      buttonText: "Open updates",
    },
    {
      title: "Firebase console",
      description:
        "Jump into Firebase for advanced storage or auth management.",
      icon: faScrewdriverWrench,
      variant: "danger",
      onClick: () =>
        window.open(
          "https://console.firebase.google.com/u/0/project/ncafiles-6e036/overview",
          "_blank",
          "noopener"
        ),
      buttonText: "Open console",
    },
  ];

  return (
    <Container fluid="lg" className="px-0">
      <Row className="g-4">
        {adminActions.map((action) => (
          <Col key={action.title} xs={12} md={6} lg={4}>
            <Card className="h-100 border-0 rounded-4 shadow-sm bg-white">
              <Card.Body className="d-flex flex-column gap-2 p-4">
                <span className="badge rounded-pill text-bg-light text-primary-emphasis mb-2 px-3 py-2 fs-5 shadow-sm">
                  <FontAwesomeIcon icon={action.icon} />
                </span>
                <Card.Title className="mb-1 text-capitalize">
                  {action.title}
                </Card.Title>
                <Card.Text className="text-muted flex-grow-1">
                  {action.description}
                </Card.Text>
                <Button
                  variant={action.variant}
                  onClick={action.onClick}
                  className="mt-2 align-self-start rounded-pill fw-semibold px-3"
                >
                  <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                  {action.buttonText}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
